module.exports = __webpack_public_path__ + "static/mapa-52364f02df29f6b8d7adbaec39872a05.png";